import { render } from "./AdvertiserBillingOverview.vue?vue&type=template&id=500bc2a6"
import script from "./AdvertiserBillingOverview.vue?vue&type=script&lang=js"
export * from "./AdvertiserBillingOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/53/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QTooltip});
